import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'
import About from '../views/About.vue'
import Solution from '../views/Solution.vue'
import Service from '@/views/Service.vue'
import Success from '@/views/Success.vue'
import News from '@/views/News.vue'
import News1 from '@/views/NewsList/News1.vue'
import News2 from '@/views/NewsList/News2.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/index' },
  { path: '/index', component: Index },
  { path: '/about', component: About },
  { path: '/solution', component: Solution },
  { path: '/service', component: Service },
  { path: '/success', component: Success },
  { path: '/News', component: News },
  { path: '/News1', component: News1 },
  { path: '/News2', component: News2 },
]

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err; // 非重复导航错误继续抛出
    }
  });
};

const router = new VueRouter({
  routes
})

export default router
